<template>
  <v-app>
    <LoadingWidget v-if="loading" />
    <template v-else>
      <HeaderShell />
      <v-main>
        <router-view v-bind="$route.meta" />
      </v-main>
      <FooterShell />
    </template>

    <CookieBannerWidget />

    <WhatsAppButtonWidget
      v-if="informations.whatsapp_float && smAndDown"
      :link="informations.whatsapp_float"
      :text="informations.float_whatsapp_title"
    />
  </v-app>
</template>

<script>
import LoadingWidget from "./components/widgets/LoadingWidget.vue";
import HeaderShell from "./components/shell/header/HeaderShell.vue";
import FooterShell from "./components/shell/FooterShell.vue";
import CookieBannerWidget from "./components/widgets/CookieBannerWidget.vue";
import WhatsAppButtonWidget from "./components/widgets/WhatsAppButtonWidget.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    updateDocumentTitle() {
      document.title = !this.name
        ? this.$route.name
        : `${this.$route.name} | ${this.name}`;
    },
  },
  watch: {
    $route() {
      this.updateDocumentTitle();
    },
    name() {
      this.updateDocumentTitle();
    },
  },
  mounted() {
    this.$rest("informations")
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  created() {
    this.updateDocumentTitle();
  },
  components: {
    LoadingWidget,
    HeaderShell,
    FooterShell,
    CookieBannerWidget,
    WhatsAppButtonWidget,
  },
};
</script>
